import { 
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
} from "@material-ui/core"

import React, { Component } from "react"

/**
 * События элемента
 * 
 * onCreateDewarClick(dewar) - запрос на добавление сосуда Дьюара.
 * onCancelClick() - запрос отмены.
 */

class CreateDewarDialog extends (Component) {

    constructor(props) {
        
        super(props)
        
        this.state = {
            code: "",
            dialog: undefined,
        }

    }

    isReady() {
        if (this.state.code === "") {
            return false
        }
        return true
    }

    render() {

        if (this.state.dialog) {
            return this.state.dialog
        }

        return <Dialog
            open = {true}
            fullWidth = {true}        
        >

            <DialogTitle>
				Добавить сосуд Дьюара
			</DialogTitle>

            <DialogContent style = {{display: "flex", flexDirection: "column"}}>
                
                <TextField
					value = {this.state.code}
					label = "Код сосуда Дьюара"
					margin = "normal"
					onChange = {e => {
						e.preventDefault()
						this.setState({code: e.target.value})
					}}                    
                />

            </DialogContent>

            <DialogActions>

                <Button
                    disabled = {!this.isReady()}
                    onClick = {e => {
                        e.stopPropagation()
                        if (typeof this.props.onCreateDewarClick === "function") {
                            this.props.onCreateDewarClick({
                                code: this.state.code,
                            })
                        }
                    }}
                >Добавить</Button>

                <Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

            </DialogActions>

        </Dialog>

    }

}

export default CreateDewarDialog